import { Box, Divider, Grid, IconButton, Menu } from '@mui/material';
import { ActionButtonProps } from 'src/core/ui/CustomButton';
import { Children, Fragment, isValidElement, useEffect, useRef, useState } from 'react';
import type { FC, ReactNode } from 'react';
import CustomButton from 'src/core/ui/CustomButton';
import MoreVertTwoToneIcon from '@mui/icons-material/MoreVertTwoTone';

export const AdditionalActions: FC<{ actionButtons?: ActionButtonProps[], children?}> = ({ actionButtons, children }) => {
  const actionRef = useRef<any>(null);
  const [isOpen, setOpenMenuLocation] = useState<boolean>(false);
  const actions = actionButtons?.filter(Boolean) ?? [];
  const menuChildren = getMenuChildren(children);
  const hasContent = actions.length > 0 || menuChildren.length > 0;
  useEffect(() => { if (!hasContent) setOpenMenuLocation(false); }, [hasContent]);
  if (hasContent) {
    return (
      <Box display="flex">
        {/* Keep the real anchor ref and popup ARIA state on this menu trigger. */}
        <IconButton aria-label="More actions" aria-haspopup="menu" aria-expanded={isOpen} sx={{ ml: 1 }} color="primary" ref={actionRef} className={"additional-actions"} onClick={() => setOpenMenuLocation(true)}>
          <MoreVertTwoToneIcon />
        </IconButton>
        <Menu disableScrollLock anchorEl={actionRef.current} className='additional-actions-menu' onClose={() => setOpenMenuLocation(false)} open={isOpen} anchorOrigin={{ vertical: 'center', horizontal: 'right' }} transformOrigin={{ vertical: 'center', horizontal: 'right' }}>
          {actions.map((actionButton, index) => (
            <Grid key={index} item>
              <CustomButton {...actionButton}></CustomButton>
            </Grid>
          ))}
          {menuChildren.map((child, index) => (<Grid key={index} item>{child}</Grid>))}
        </Menu>
      </Box>
    );
  } else {
    return <></>;
  }
};

const getMenuChildren = (children: ReactNode): ReactNode[] => Children.toArray(children).flatMap(child => isValidElement<{ children?: ReactNode }>(child) && child.type === Fragment ? getMenuChildren(child.props.children) : typeof child === 'string' && !child.trim() ? [] : [child]);

const defaultVariant = 'contained';

const LineContianer: FC<{ actionButton: ActionButtonProps }> = ({ actionButton }) => {
  return (
    <Grid key={actionButton.title} item>
      <CustomButton {...actionButton}></CustomButton>
      <Divider />
    </Grid>
  );
};

export default AdditionalActions;
